import { ICommand } from 'core-ts-types';
import { PlatformUtility } from 'utility-ts-platform';
import { SurveyStepService } from '../../data/services/survey_step_service';

export class SurveyStepFooterController {
  constructor(
    private myIntakeModel: any,
    private $state: ng.ui.IStateService,
    private ngSurveyStepService: SurveyStepService,
    private updateTaskStatusCommand: ICommand,
    private TaskStatusEnum: any,
    private log: any
  ) {}

  completeSurvey(): void {
    this.updateTaskStatusCommand(this.myIntakeModel.source.source.task, this.TaskStatusEnum.COMPLETED).then(() => {
      this.log.user.success('Major Explorer Completed');
      this.$state.go('my.majorexplorer');
    });
  }

  isDesktop(): boolean {
    return PlatformUtility.isDesktop();
  }
}

export class SurveyStepFooterComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-major-explorer/src/components/survey_step_footer/survey_step_footer.html';
  public controller: any = SurveyStepFooterController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/survey_step_footer/survey_step_footer.ts